module.exports = __webpack_public_path__ + "img/review.160a4ebb.svg";